import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SwiperModule } from 'swiper/angular';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home/home.component';
import { SectionBenefitsComponent } from './home/sections/section-benefits/section-benefits.component';
import { SectionCompanyComponent } from './home/sections/section-company/section-company.component';
import { SectionFeaturesComponent } from './home/sections/section-features/section-features.component';
import { SectionHeadingComponent } from './home/sections/section-heading/section-heading.component';
import { SectionPricingComponent } from './home/sections/section-pricing/section-pricing.component';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { LegalNoticeComponent } from './legal-notice/legal-notice.component';
import { MainNavMobileComponent } from './main-nav-mobile/main-nav-mobile.component';
import { MainNavComponent } from './main-nav/main-nav.component';
import { PrivacyPolicyManagementComponent } from './privacy-policy-management/privacy-policy-management.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ScrollTopButtonComponent } from './scroll-top-button/scroll-top-button.component';
import { SecondaryNavComponent } from './secondary-nav/secondary-nav.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    MainNavComponent,
    SectionHeadingComponent,
    SectionBenefitsComponent,
    SectionFeaturesComponent,
    SectionPricingComponent,
    SectionCompanyComponent,
    ScrollTopButtonComponent,
    FooterComponent,
    SecondaryNavComponent,
    LegalNoticeComponent,
    HomeComponent,
    PrivacyPolicyComponent,
    PrivacyPolicyManagementComponent,
    MainNavMobileComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({
      appId: 'ubilaw-web'
    }),
    AppRoutingModule,
    FontAwesomeModule,
    SwiperModule,
    // CKEditorModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  providers: [
    {
      provide: 'env',
      useValue: environment
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
